import { Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles<Theme>(theme => ({
  backButton: {
    left: 0,
    position: 'absolute',
    top: 0,
  },
  bodyContainer: {
    overflowY: 'scroll',
  },
  closeButton: {
    position: 'absolute',
    right: 0,
    top: 0,
  },
  header: {
    marginBottom: theme.spacing(2),
    position: 'relative',
  },
  paper: {
    borderTopLeftRadius: theme.spacing(3),
    borderTopRightRadius: theme.spacing(3),
    maxHeight: 'calc(100% - 85px)',
    padding: theme.spacing(5, 3),
  },
  titleContainer: {
    height: theme.spacing(5),
    marginLeft: theme.spacing(5),
    marginRight: theme.spacing(5),
  },
}));

export default useStyles;
